import { createFileRoute } from '@tanstack/react-router';
import { TenantDetailPage } from '@/pages/TenantDetailPage';

export const Route = createFileRoute('/_auth/tenant/$tenantId')({
  component: TenantDetailPage,
});
